import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditPlatformsReady} from '../redux/platforms'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'

//import * as Helpers from '../../../common/helpers'

import {EntityStatus} from '../../../common/DropDowns/index'

class AddEditPlatforms extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        platformsName: "",
        status:"",
        platformsData:{},


        platformsNameErrorText: false,
        platformsNameErrorData: '',

        statusErrorText: false,
        statusErrorData: '',

        subTitle: Constants.ADD_PLATFORM

    }

    this.isComponentStillMounted = true

    this.statusComponent = null
    this.statusSection = null

    this.platformsNameComponent = null
    this.platformsNameSection = null

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditPlatformsReady(false))

    if (this.props.platforms && this.props.platforms.platformsSelectedId && this.props.platforms.platformsSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_PLATFORM))
        this.setState({
            subTitle: "Edit Platform",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_PLATFORM))
        this.setState({
            subTitle: "Add Platform"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.platforms && this.props.platforms.platformsSelectedId && this.props.platforms.platformsSelectedId !== null) {
        this.getPlatformsById(this.props.platforms.platformsSelectedId)
    }else{

    this.props.dispatch(addEditPlatformsReady(true))
    }
}

componentDidMount() {

        this.platformsNameSection = ReactDOM.findDOMNode(this.refs.platformsNameSection)
        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}



 entityStatusChange = (data) => {
    this.statusComponent.value=data.value
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }

onSaveClick = () => {

    this.props.dispatch(addEditPlatformsReady(false))
    let data = {}

    let platformsNameObject = this.mandateValidation("platformsName", Constants.FORM_INPUT)
    if (platformsNameObject.status) {
        data.name = this.platformsNameComponent.value
    } else {

         this.props.dispatch(addEditPlatformsReady(true))
        return
    }

    if(this.state.editFlag){

    let statusObject = this.mandateValidation("status", Constants.FORM_INPUT)
    if (statusObject.status) {
        data.status = this.statusComponent.value
    } else {

         this.props.dispatch(addEditPlatformsReady(true))
        return
    }

    }else{
        data.status="ACTIVE"
    }


    let apiPayloadData=data;


    if(this.state.editFlag){


        apiService.editPlatforms(apiPayloadData,this.state.platformsData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditPlatformsReady(true))
                        this.props.history.push("/dashboard/platforms/list")
                    } else {

                        this.props.dispatch(addEditPlatformsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditPlatformsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addPlatforms(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditPlatformsReady(true))
                        this.props.history.push("/dashboard/platforms/list")
                    } else {

                        this.props.dispatch(addEditPlatformsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditPlatformsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getPlatformsById = (id) => {
    apiService.getPlatformsById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        platformsData: responseData.data ,
                        platformsName : responseData.data.name,
                        status : responseData.data.status               
                    })

                    if (this.isComponentStillMounted) {
                        this.platformsNameComponent.value=responseData.data.name
                        this.statusComponent.value=responseData.data.status
                    }

                    this.props.dispatch(addEditPlatformsReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditPlatformsReady(true))
        })
}








    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.platformsNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Platform Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Platform Name" type="text" ref={el => this.platformsNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("platformsName")}} />
                                                        <span className="help-block"style={{display: this.state.platformsNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.platformsNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                          <div className="col-md-12 col-sm-12 col-xs-12">

                                         {(() => {

                                       if(this.state.editFlag){
                                         
                                        return (

                                        
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.statusSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "center", paddingTop: "0px"}}>Status *</label>
                                                    <div className="col-sm-9" ref={el => this.statusComponent = el}>
                                                       
                                                    <EntityStatus type="PLATFORMS" entityStatusChange={this.entityStatusChange} selectedValue={this.state.status} />


                                                        <span className="help-block"style={{display: this.state.statusErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.statusErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                                                                   

                                        )

                                    }
                                    })()} 
                                    </div>
                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        platforms: state.platforms,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditPlatforms))


// WEBPACK FOOTER //
// ./src/modules/Platforms/Components/AddEditPlatforms.js